import React from 'react';
import { useTheme } from '@mui/material';
import DSBox from '../DSBox';
import DSTypography from '../Typography/DSTypography';
import DSCalendarDay from './DSCalendarDay';
import {
  generateCalendarDays,
  getDayNames,
  getRequiredWeeksForMonth,
} from './utils/calendarUtils';
import { CalendarEvent } from '../../api/calendarEvent';
import { KLYDO_WHITE } from '../../consts/colors';

type DSCalendarProps = {
  currentDate: Date;
  calendarEvents?: CalendarEvent[];
  onPlusClick: (calendarEventId?: string) => void;
};

const DSCalendar = ({
  currentDate,
  calendarEvents = [],
  onPlusClick,
}: DSCalendarProps) => {
  const { spacing, breakpoints } = useTheme();
  const dayNames = getDayNames();
  const calendarDays = generateCalendarDays(currentDate, calendarEvents);
  const requiredWeeks = getRequiredWeeksForMonth(currentDate);

  return (
    <DSBox
      sx={{
        borderRadius: '17px',
        padding: spacing(2),
        overflow: 'hidden',
        minHeight: `${requiredWeeks * 140 + 120}px`,
        [breakpoints.down('md')]: {
          padding: spacing(1),
          minHeight: `${requiredWeeks * 100 + 80}px`,
        },
      }}
    >
      <DSBox
        sx={{
          display: 'flex',
          width: '100%',
          marginBottom: spacing(1),
        }}
      >
        {dayNames.map((dayName) => (
          <DSBox
            key={dayName}
            sx={{
              flex: 1,
              padding: spacing(2, 1),
              textAlign: 'center',
            }}
          >
            <DSTypography
              sx={{
                color: KLYDO_WHITE,
                fontFamily: 'Gilroy-Bold',
                fontWeight: '600',
                fontSize: '0.875rem',
                textTransform: 'capitalize',
                letterSpacing: '0.5px',
              }}
            >
              {dayName}
            </DSTypography>
          </DSBox>
        ))}
      </DSBox>

      <DSBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        {Array.from({ length: requiredWeeks }).map((_, weekIndex) => (
          <DSBox
            key={weekIndex}
            sx={{
              display: 'flex',
              flex: 1,
              minHeight: '140px',
              [breakpoints.down('md')]: {
                minHeight: '100px',
              },
            }}
          >
            {calendarDays
              .slice(weekIndex * 7, (weekIndex + 1) * 7)
              .map((day, dayIndex) => (
                <DSBox
                  key={`${weekIndex}-${dayIndex}`}
                  sx={{
                    width: '14.28%',
                    padding: spacing(0.5),
                    [breakpoints.down('md')]: {
                      padding: spacing(0.25),
                    },
                  }}
                >
                  <DSCalendarDay day={day} onClick={onPlusClick} />
                </DSBox>
              ))}
          </DSBox>
        ))}
      </DSBox>
    </DSBox>
  );
};

export default DSCalendar;
